export default {
  QInput: {
    charNumber: 'Количество символов'
  },
  QSelect: {
    loading: 'Загрузка...',
    more: 'Показаны не все результаты, уточните поиск',
    noMatch: 'Нет совпадений',
    noData: 'Нет данных',
    selectAll: 'Выбрать всё'
  },
  QTextarea: {
    charNumber: 'Количество символов'
  },
  QDatePicker: {
    placeholder: 'Выберите дату',
    startPlaceholder: 'Дата начала',
    endPlaceholder: 'Дата окончания',
    prevYear: 'Предыдущий год',
    nextYear: 'Следующий год',
    prevMonth: 'Предыдущий месяц',
    nextMonth: 'Следующий месяц',
    timeFrom: 'с',
    timeTo: 'по'
  },
  QCascader: {
    placeholder: 'Выберите',
    noDataText: 'Нет данных'
  },
  QColorPicker: {
    clear: 'Очистить',
    confirm: 'Применить'
  },
  QTable: {
    noData: 'Нет данных'
  },
  QTimePicker: {
    hour: 'час',
    minute: 'мин',
    second: 'сек'
  },
  QUpload: {
    uploadFile: 'загрузить файл',
    replaceFile: 'заменить файл',
    loading: 'загрузка'
  }
};
